import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home0',
    component: Home,
    meta: {
      field: 'cdepartamento',
      defaultSelected: 'LIMA',
      title: 'Departamento',
      placeholder: 'Selecciona un departamento',
      level: 0
    }
  },
  {
    path: '/:departamentoId',
    name: 'Home1',
    component: Home,
    meta: {
      field: 'cprovincia',
      defaultSelected: 'LIMA',
      title: 'Provincia',
      placeholder: 'Selecciona una provincia',
      level: 1,
      compareFunction: (ubigeo, value) => ubigeo.cdepartamento === value
    }
  },
  {
    path: '/:departamentoId/:provinciaId',
    name: 'Home2',
    component: Home,
    meta: {
      field: 'cdistrito',
      title: 'Distrito',
      placeholder: 'Selecciona un distrito',
      level: 2,
      compareFunction: (ubigeo, value1, value2) => (
        ubigeo.cdepartamento === value1 &&
        ubigeo.cprovincia === value2
      )
    }
  },
  {
    path: '/:departamentoId/:provinciaId/:distritoId',
    name: 'Home3',
    component: Home,
    meta: {
      field: 'cdistrito',
      level: 3,
      compareFunction: (ubigeo, value1, value2, value3) => (
        ubigeo.cdepartamento === value1 &&
        ubigeo.cprovincia === value2 &&
        ubigeo.cdistrito === value3
      )
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
